export default __webpack_public_path__ + "static/finance-2-c62978afc7a3c6d8bd6843d215e52b74.png";